import { getUrlApi } from "../utilities/util";
import ApiHandler from "./ApiHandlers/ApiHandler";

export const baseURL = String(getUrlApi());

export default class FailureApi {
  static async GetAllCauses(): Promise<any> {
    return ApiHandler(baseURL).get(`/cause/getall`);
  }

  static async GetOperationById(culture: string, id: number): Promise<any> {
    return ApiHandler(baseURL).get(
      `${culture}/operation/getoperationbyid/${id}`,
    );
  }

  static async Create(formData: FormData): Promise<any> {
    return ApiHandler(baseURL).post(`/failures`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  static async GetByFilterAsync(
    plantIds: string[],
    pageNumber: number = 1,
    pageSize: number = 10,
    sortField: string = "name",
    sortDirection: string = "asc",
    description?: string,
    effect?: string,
    causeIds?: string[],
    severity?: number,
    occurrence?: number,
    detectability?: number,
    operationName?: string,
    version?: number,
    rpn?: number,
    code?: string,
    fmeaTitle?: string,
    fmeaIds?: string[],
    productionUnitIds?: string[],
    areaIds?: string[],
    lineIds?: string[],
    subLineIds?: string[],
    partNumbers?: string[],
  ): Promise<any> {
    // Começa a montar a query
    let url = `/failures/filter?`;
    // plantId[]
    plantIds.forEach((id) => {
      url += `plantIds=${encodeURIComponent(id)}&`;
    });
    // paginação e ordenação
    url += `pageNumber=${pageNumber}&pageSize=${pageSize}`;
    url += `&sortField=${encodeURIComponent(sortField)}`;
    url += `&sortDirection=${encodeURIComponent(sortDirection)}`;

    // filtros opcionais

    if (description) url += `&description=${encodeURIComponent(description)}`;
    if (version !== undefined) url += `&version=${version}`;
    if (effect) url += `&effect=${encodeURIComponent(effect)}`;
    if (operationName) url += `&nameOperation=${operationName}`;

    if (severity != null) url += `&severity=${severity}`;
    if (occurrence != null) url += `&occurrence=${occurrence}`;
    if (detectability != null) url += `&detectability=${detectability}`;

    if (rpn != null) url += `&rpn=${rpn}`;
    
    if (fmeaTitle) url += `&fmeaTitle=${encodeURIComponent(fmeaTitle)}`;
    fmeaIds?.forEach(id => {
      url += `&fmeaIds=${encodeURIComponent(id)}`;
    });
    if (code) url += `&code=${code}`;
    // arrays de filtros
    causeIds?.forEach((id) => {
      url += `&causeIds=${encodeURIComponent(id)}`;
    });

    productionUnitIds?.forEach((id) => {
      url += `&productionUnitIds=${encodeURIComponent(id)}`;
    });
    areaIds?.forEach((id) => {
      url += `&areaIds=${encodeURIComponent(id)}`;
    });
    lineIds?.forEach((id) => {
      url += `&lineIds=${encodeURIComponent(id)}`;
    });
    subLineIds?.forEach((id) => {
      url += `&subLineIds=${encodeURIComponent(id)}`;
    });
    partNumbers?.forEach((id) => {
      url += `&partNumbers=${encodeURIComponent(id)}`;
    });

    return ApiHandler(baseURL).get(url);
  }

  static async Update(failure: {
  id: string;
  description: string;
  effect: string;
  causeId?: string;
  causeDescription?: string;
  severity: number;
  occurrence: number;
  detectability: number;
  }): Promise<any> {
    return ApiHandler(baseURL).put(`/failures/${failure.id}`, failure);
  }

  static async Delete(id: string): Promise<any> {
    return ApiHandler(baseURL).delete(`/failures/${id}`, {
      headers: {
        "Content-Type": "application/json-patch+json",
      },
    });
  }

  static async GetFailureResponseById(id: string): Promise<any> {
    return ApiHandler(baseURL).get(`/failures/${id}/response?`);
  }

  static async GetVersionHistory(
    failureId: string,
    page = 1,
    size = 9,
  ): Promise<any> {
    const params = new URLSearchParams({
      failureId,
      pageNumber: String(page),
      pageSize: String(size),
      sortField: "DateVersioned",
      sortDirection: "desc",
    });
    return ApiHandler(baseURL).get(
      `/failureversions/filter?${params.toString()}`,
    );
  }

  static async GetImportedFailures(
    fmeaId: string
  ): Promise<any> {
    return ApiHandler(baseURL).get(
      `/failures/imported/${encodeURIComponent(fmeaId)}`
    );
  }
}
